import moment from "moment";
import React from "react";
import { Table } from "@material-ui/core";
export var OrderTableUser = function (props) {
    var user = props.currentUser;
    var orders = props.orders.map(function (order) { return (React.createElement("tr", { key: order.id },
        React.createElement("td", null, order.id),
        React.createElement("td", null,
            user.firstName,
            " ",
            user.lastName),
        React.createElement("td", null,
            React.createElement("b", null, user.company),
            React.createElement("br", null),
            user.address,
            React.createElement("br", null),
            user.city),
        React.createElement("td", null,
            Number(order.monthly.amount).toFixed(2),
            " ",
            order.monthly.currency),
        order.discount === null ? React.createElement("td", null, "-") : React.createElement("td", null,
            order.discount,
            " %"),
        React.createElement("td", null, order.locations),
        React.createElement("td", null,
            order.length,
            " Months"),
        React.createElement("td", null, moment(order.start).format("L") + " - " + moment(order.end).format("L")),
        order.status === "pending" ? (React.createElement("td", { className: "orange-text text-darken-2" }, "Pending")) : order.status === "inactive" ? (React.createElement("td", { className: "red-text" }, "Inactive")) : order.status === "approved" ? (React.createElement("td", { className: "green-text text-lighten-1" }, "Approved")) : (React.createElement("td", { className: "green-text text-darken-2" }, "Active")))); });
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col s12 m12 l12" },
            React.createElement("h5", { className: "" }, "Your Orders"),
            React.createElement("br", null),
            React.createElement("div", { className: "card-panel" },
                React.createElement(Table, null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "No."),
                            React.createElement("th", null, "Contact"),
                            React.createElement("th", null, "Customer"),
                            React.createElement("th", null, "Monthly Amount"),
                            React.createElement("th", null, "Discount"),
                            React.createElement("th", null, "Locations"),
                            React.createElement("th", null, "Length"),
                            React.createElement("th", null, "Period"),
                            React.createElement("th", null, "Status"))),
                    React.createElement("tbody", null, orders))))));
};
export default OrderTableUser;



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderTableUser.tsx
// module id = 1243
// module chunks = 0